define(
  'app/factories/simple_slider',['app/setup', 'app/views/simple_slider'],
  function(takhfifan, simpleSlider) {
    $(function($) {
      var $el = $('.tkh-slider');
      if ($el.length > 0) {
        $el.each(function() {
          new takhfifan.simpleSlider({
            el: $(this)
          });
        });
      }
    });
  });

